// trips-mock.ts — Mock trip + e-ticket data for TripsPage and ETicketPage.
// TODO(trips-api-PR): Replace with real GET /trips + GET /bookings/:pnr when trips BE lands.

export type TripStatus = 'confirmed' | 'completed' | 'cancelled';

export interface MockTrip {
  id: string;
  pnr: string;
  airline: string;
  airlineCode: string;
  airlineColor: string;
  from: string;
  fromCity: string;
  to: string;
  toCity: string;
  depart: string;
  arrive: string;
  departDate: string;
  returnDate?: string;
  duration: string;
  flightNumber: string;
  passengers: string[];
  status: TripStatus;
  price: number;
  seat: string;
  gate: string;
  terminal: string;
  boardingTime: string;
  aircraft: string;
  cabinClass: string;
  img: string;
}

const IMG = (id: string, w = 800) =>
  `https://images.unsplash.com/photo-${id}?w=${w}&q=80&auto=format&fit=crop`;

export const UPCOMING_TRIPS: MockTrip[] = [
  {
    id: 'trip-001',
    pnr: 'GF7X2A',
    airline: 'Singapore Airlines',
    airlineCode: 'SQ',
    airlineColor: '#1B3A6B',
    from: 'BLR',
    fromCity: 'Bengaluru',
    to: 'DPS',
    toCity: 'Bali',
    depart: '23:55',
    arrive: '12:10',
    departDate: '17 Jun 2026',
    returnDate: '24 Jun 2026',
    duration: '11h 15m',
    flightNumber: 'SQ 503',
    passengers: ['Rahul Sharma', 'Priya Sharma'],
    status: 'confirmed',
    price: 97800,
    seat: '14F',
    gate: 'B14',
    terminal: 'T2',
    boardingTime: '23:25',
    aircraft: 'A350',
    cabinClass: 'Economy',
    img: IMG('1537996194471-e657df975ab4'),
  },
  {
    id: 'trip-002',
    pnr: 'GF4K9M',
    airline: 'IndiGo',
    airlineCode: '6E',
    airlineColor: '#0B1F8C',
    from: 'BLR',
    fromCity: 'Bengaluru',
    to: 'DEL',
    toCity: 'Delhi',
    depart: '06:25',
    arrive: '09:15',
    departDate: '3 Jul 2026',
    duration: '2h 50m',
    flightNumber: '6E 2341',
    passengers: ['Rahul Sharma'],
    status: 'confirmed',
    price: 5499,
    seat: '22A',
    gate: 'A8',
    terminal: 'T1',
    boardingTime: '05:55',
    aircraft: 'A320neo',
    cabinClass: 'Economy',
    img: IMG('1524492412937-b28074a5d7da'),
  },
  {
    id: 'trip-003',
    pnr: 'GF1R5T',
    airline: 'Air India',
    airlineCode: 'AI',
    airlineColor: '#B8111A',
    from: 'DEL',
    fromCity: 'Delhi',
    to: 'LHR',
    toCity: 'London',
    depart: '14:40',
    arrive: '19:25',
    departDate: '15 Aug 2026',
    returnDate: '30 Aug 2026',
    duration: '9h 45m',
    flightNumber: 'AI 111',
    passengers: ['Rahul Sharma'],
    status: 'confirmed',
    price: 62400,
    seat: '34B',
    gate: 'D22',
    terminal: 'T3',
    boardingTime: '14:05',
    aircraft: 'B777',
    cabinClass: 'Economy',
    img: IMG('1513635269975-59663e0ac1ad'),
  },
];

export const PAST_TRIPS: MockTrip[] = [
  {
    id: 'trip-101',
    pnr: 'GF8N2P',
    airline: 'Singapore Airlines',
    airlineCode: 'SQ',
    airlineColor: '#1B3A6B',
    from: 'BLR',
    fromCity: 'Bengaluru',
    to: 'HND',
    toCity: 'Tokyo',
    depart: '01:30',
    arrive: '14:45',
    departDate: '3 Mar 2026',
    returnDate: '10 Mar 2026',
    duration: '9h 15m',
    flightNumber: 'SQ 636',
    passengers: ['Rahul Sharma', 'Meera Nair'],
    status: 'completed',
    price: 142600,
    seat: '18C',
    gate: 'C12',
    terminal: 'T2',
    boardingTime: '01:00',
    aircraft: 'A380',
    cabinClass: 'Economy',
    img: IMG('1540959733332-eab4deabeeaf'),
  },
  {
    id: 'trip-102',
    pnr: 'GF3D7Q',
    airline: 'Air Asia X',
    airlineCode: 'D7',
    airlineColor: '#FF0050',
    from: 'BLR',
    fromCity: 'Bengaluru',
    to: 'DPS',
    toCity: 'Bali',
    depart: '06:25',
    arrive: '14:50',
    departDate: '18 Dec 2025',
    returnDate: '28 Dec 2025',
    duration: '8h 25m',
    flightNumber: 'D7 196',
    passengers: ['Rahul Sharma'],
    status: 'completed',
    price: 34800,
    seat: '12A',
    gate: 'B6',
    terminal: 'T1',
    boardingTime: '05:55',
    aircraft: 'A330',
    cabinClass: 'Economy',
    img: IMG('1537996194471-e657df975ab4'),
  },
  {
    id: 'trip-103',
    pnr: 'GF9B4W',
    airline: 'TAP Air Portugal',
    airlineCode: 'TP',
    airlineColor: '#008E5E',
    from: 'BLR',
    fromCity: 'Bengaluru',
    to: 'LIS',
    toCity: 'Lisbon',
    depart: '22:15',
    arrive: '07:30',
    departDate: '10 Aug 2025',
    returnDate: '18 Aug 2025',
    duration: '13h 15m',
    flightNumber: 'TP 1490',
    passengers: ['Rahul Sharma', 'Arjun Kumar'],
    status: 'completed',
    price: 118200,
    seat: '29D',
    gate: 'E4',
    terminal: 'T2',
    boardingTime: '21:45',
    aircraft: 'A321neo',
    cabinClass: 'Economy',
    img: IMG('1555881400-74d7acaacd8b'),
  },
  {
    id: 'trip-104',
    pnr: 'GF6C1L',
    airline: 'Qatar Airways',
    airlineCode: 'QR',
    airlineColor: '#5C0931',
    from: 'BLR',
    fromCity: 'Bengaluru',
    to: 'KEF',
    toCity: 'Reykjavík',
    depart: '03:40',
    arrive: '16:55',
    departDate: '5 Feb 2025',
    returnDate: '12 Feb 2025',
    duration: '14h 15m via DOH',
    flightNumber: 'QR 521',
    passengers: ['Rahul Sharma'],
    status: 'completed',
    price: 94500,
    seat: '41E',
    gate: 'A31',
    terminal: 'T3',
    boardingTime: '03:10',
    aircraft: 'B787',
    cabinClass: 'Economy',
    img: IMG('1504829857797-ddff29c27927'),
  },
];

export const CANCELLED_TRIPS: MockTrip[] = [
  {
    id: 'trip-201',
    pnr: 'GF2H8V',
    airline: 'Emirates',
    airlineCode: 'EK',
    airlineColor: '#D71921',
    from: 'BLR',
    fromCity: 'Bengaluru',
    to: 'DXB',
    toCity: 'Dubai',
    depart: '08:50',
    arrive: '11:30',
    departDate: '20 Apr 2026',
    duration: '3h 40m',
    flightNumber: 'EK 568',
    passengers: ['Rahul Sharma', 'Priya Sharma'],
    status: 'cancelled',
    price: 28400,
    seat: '27C',
    gate: 'D7',
    terminal: 'T3',
    boardingTime: '08:20',
    aircraft: 'B777',
    cabinClass: 'Economy',
    img: IMG('1512453979798-5ea266f8880c'),
  },
];

// Keyed by PNR for fast lookup from ETicketPage
export const ETICKETS: Record<string, MockTrip> = Object.fromEntries(
  [...UPCOMING_TRIPS, ...PAST_TRIPS, ...CANCELLED_TRIPS].map(t => [t.pnr, t]),
);
